module.exports = __webpack_public_path__ + "static/media/logo.d481ea0f.svg";